import React, { useRef } from 'react';
import { Button } from '../utils/thirdpartyComponents';
import QRCode from 'qrcode.react';

interface QRCodeComponentProps {
  value: string;
  equipment_name: string;
}

const QRCodeComponent: React.FC<QRCodeComponentProps> = ({ value, equipment_name }) => {
  const qrRef = useRef<HTMLDivElement>(null);
  // const formattedName = equipment_name.replace(/[^a-zA-Z0-9]/g, '-');
  const  formattedName = equipment_name
  // const downloadQRCode = () => {
  //   const canvas = qrRef.current?.querySelector('canvas');
  //   if (canvas) {
  //     const pngFile = canvas.toDataURL('image/png');
  //     const downloadLink = document.createElement('a');
  //     downloadLink.href = pngFile;
  //     downloadLink.download = `${formattedName}_QRCode.png`;
  //     downloadLink.click();
  //   }
  // };

  const downloadQRCode = () => {
    const svg:any = qrRef.current?.querySelector("svg");
    const svgXML = new XMLSerializer().serializeToString(svg);
    const dataUrl = "data:image/svg," + encodeURIComponent(svgXML);

    const anchor = document.createElement("a");
    anchor.href = dataUrl;
    anchor.download = `${formattedName}_QRCode.svg`;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };


  return (
    <div>
      <div ref={qrRef}>
        <QRCode
          value={value}
          size={256}
          level={'H'}
          includeMargin={true}
          renderAs='svg'
        />
      </div>
      <Button onClick={downloadQRCode} variant="primary" className="primary-btn download-btn" title="Download QR Code">Download QR Code</Button>
    </div>
  );
};

export default QRCodeComponent;
